import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=75a9db86&scoped=true"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"
import style0 from "./Marquee.vue?vue&type=style&index=0&id=75a9db86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9db86",
  null
  
)

export default component.exports